var app = angular.module("leonardo");


var ReportsQuickList = function($scope, $state, $filter, FilterService, ngDialog, QuickReportsService,
                                ReportService, AuthDataService, ReportFilterService,
                                AccountUserService, PermissionService, $rootScope, $timeout, AnalyticsService) {

  $scope.reports = [];
  $scope.reportExpanded = null;
  $scope.mode = $state.current.mode;
  $scope.superuser = $state.current.superuser || false;
  $scope.authDataService = AuthDataService;
  $scope.reportService = ReportService;
  $scope.report_types = angular.copy(ReportService.TYPE_OPTIONS);

  $scope.showCloneAdminDialog = function (report) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/admin/clone-element.html',
      controller: 'CloneTypeDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        onlyClientInstance: true,
        type: 'quick report',
      }
    }).then(function (result) {
      if (result.type_result === 'client_instance') {
        report.cloneToWhiteLabel({clientinstances: result.client_instance}).then(function () {
          $scope.refresh();
        });
      }
    });
  };

  $scope.refresh = function() {
    var data = {
      disable_pagination: true,
      only_superuser: $scope.superuser,
      summary: true
    };
    data.report_type = FilterService.hasFilter('report_type') ? FilterService.getFilter('report_type') : null;
    if($scope.mode !== 'system') {
      data.account = FilterService.hasFilter('my_reports_account_filter') ? FilterService.getFilter('my_reports_account_filter') : null;
    }
    if($scope.mode === 'system') {
      data.system = 1;
    }
    else {
      data.system = 0;
    }
    QuickReportsService.getlist(data, true).then(function(results){
      $scope.reports = results;
      $scope.groupReports($scope.reports);
    });

  };

  $scope.groupReports = function(reports) {
    $scope.reportsGrouped = [];
    angular.forEach($scope.report_types, function(value) {
      $scope.reportsGrouped.push({id: value.id, reports: []});
    });
    angular.forEach(reports, function(value) {
      if ($scope.reportsGrouped[$scope.getIndexType(value.report_type)]) {
        $scope.reportsGrouped[$scope.getIndexType(value.report_type)].reports.push(value);
      }
    });
    angular.forEach($scope.reportsGrouped, function(group) {
      group.reports = $filter('orderBy')(group.reports, 'name');
    });
  };

  $scope.getIndexType = function(type_id) {
    var index = -1;
    angular.forEach($scope.reportsGrouped, function(value, key){
      if (value.id == type_id) {
        index = key;
      }
    });
    return index;
  };

  $scope.goToReport = function (report_type) {
    if (!isNull(report_type)) {
      switch (report_type.toString()) {
        case ReportService.TYPE_ACTION_ITEM :
          if ($scope.superuser) {
            $state.go('reports.admin-action-item');
          }
          else {
            $state.go('reports.action-item');
          }
          break;
        case ReportService.TYPE_ACTIVITY :
          if ($scope.superuser) {
            $state.go('reports.admin-activity');
          }
          else {
            $state.go('reports.activity');
          }
          break;
        case ReportService.TYPE_UNIT:
          if ($scope.superuser) {
            $state.go('reports.admin-unit');
          }
          else {
            $state.go('reports.unit');
          }
          break;
        case ReportService.TYPE_WORKFLOW:
          if ($scope.superuser) {
            $state.go('reports.admin-workflow');
          }
          else {
            $state.go('reports.workflow');
          }
          break;
        case ReportService.TYPE_DYNAMIC_FORM:
          if ($scope.superuser) {
            $state.go('reports.admin-dynamic');
          }
          else {
            $state.go('reports.dynamic');
          }
          break;
        case ReportService.TYPE_DYNAMIC_FORM_STATISTIC:
          if ($scope.superuser) {
            $state.go('reports.admin-statistic');
          }
          else {
            $state.go('reports.statistic');
          }
          break;
        case ReportService.TYPE_TEMPLATE:
          if ($scope.superuser) {
            $state.go('reports.admin-template');
          }
          else {
            $state.go('reports.template');
          }
          break;
        case ReportService.TYPE_PROPERTY:
          if ($scope.superuser) {
            $state.go('reports.admin-property');
          }
          else {
            $state.go('reports.property');
          }
          break;
        case ReportService.TYPE_USER:
          if ($scope.superuser) {
            $state.go('reports.admin-user');
          }
          else {
            $state.go('reports.user');
          }
          break;
        case ReportService.TYPE_EXISTING_DOCUMENTS :
          if ($scope.superuser) {
            $state.go('reports.admin-documents');
          }
          else {
            $state.go('reports.documents');
          }
          break;
        case ReportService.TYPE_ON_DEMAND_INSTRUCTION:
          if ($scope.superuser) {
            $state.go('reports.admin-on-demand-instruction');
          }
          else {
            $state.go('reports.on-demand-instruction');
          }
          break;
        case ReportService.TYPE_PROPERTY_AMENITIES:
          if ($scope.superuser) {
            $state.go('reports.admin-property-amenities');
          }
          else {
            $state.go('reports.property-amenities');
          }
          break;
        case ReportService.TYPE_MISSING_DOCUMENTS :
          if ($scope.superuser) {
            $state.go('reports.admin-missing-documents');
          }
          else {
            $state.go('reports.missing-documents');
          }
          break;
        case ReportService.TYPE_WORK_ORDERS :
          if ($scope.superuser) {
            $state.go('reports.admin-work-orders');
          }
          else {
            $state.go('reports.work-orders');
          }
          break;
        case ReportService.TYPE_CONTACT :
          if ($scope.superuser) {
            $state.go('reports.admin-contact');
          }
          else {
            $state.go('reports.contact');
          }
          break;
        case ReportService.TYPE_MIMO:
          if ($scope.superuser) {
            $state.go('reports.admin-mimo');
          }
          else {
            $state.go('reports.mimo');
          }
          break;
        default:
          if ($scope.superuser) {
            $state.go('reports.action-item');
          }
          else {
            $state.go('reports.action-item');
          }
          break;
      }
    }
  };

  function hasHierarchyFilter() {
    return FilterService.hasFilter('property_reports') ||
           FilterService.hasFilter('portfolio_reports') ||
           FilterService.hasFilter('group_reports') ||
           FilterService.hasFilter('managed_by_reports');
  }

  $scope.quickReport = function(report){
    $scope.reportExpanded = null;
    let reportSection = '';
    if (report.report_type.toString()) {
      const reportType = ReportService.TYPE_OPTIONS.find(type => type.id == report.report_type.toString());
      reportSection = reportType ? reportType.name.toUpperCase() : '';
    }
    
    // Track report generation event when user clicks to run a report
    AnalyticsService.track('Report Generated', {
      report_name: report.name,
      report_section: reportSection
    });
    
    QuickReportsService.get(report.id).then(function(result) {
      $rootScope.$broadcast('no_reset_filters:updated', true);
      
      FilterService.clearFilters(true);
      var filters = [];
      var key_aux = '';
      angular.forEach(result.filters, function(filter, key) {
        if (_.contains(['account', 'managed_by', 'group', 'portfolio', 'property'], key)) {
          key_aux = key + '_reports';
          FilterService.setFilter(key_aux, filter);
          if (!isEmpty(filter)) {
            filters.push(key_aux);
          }
        }
        else if (_.contains(['fields', 'fields_to_show', 'fieldsToShow', 'dynamic_fields'], key)) {
          FilterService.setFilter('fields_active', filter, true);
          filters.push('fields_active');
        }
        else {
          if (key === 'fields_active' && report.report_type.toString() !== ReportService.TYPE_DYNAMIC_FORM && !isEmpty(filter) && result.filters.extra_fields) {
            // Check for extra_fields and remove those values from the fields_active
            const extraFields = result.filters.extra_fields.split(',');
            const filterArray = filter.split(',').filter(field => !extraFields.includes(field));
            const default_fields = (() => {
              switch (report.report_type.toString()) {
                case ReportService.TYPE_ACTION_ITEM:
                  return ReportService.defaultActionItemsFields;
                case ReportService.TYPE_PROPERTY_AMENITIES:
                  return ReportService.defaultFieldsReportPropertyAmenities;
                case ReportService.TYPE_PROPERTY:
                  return ReportService.defaultFieldsReportProperty;
                default:
                  return []; // Fallback for any unexpected type
              }
            })();

            const isDefaultOnly = default_fields.length === filterArray.length && filterArray.every((element) => default_fields.includes(element));

            if (!isDefaultOnly) {
              FilterService.setFilter(key, filter);
              if (!isEmpty(filter)) {
                filters.push(key);
              }
            }
          } else {
            FilterService.setFilter(key, filter);
            if (!isEmpty(filter)) {
              filters.push(key);
            }
          }
        }
      });

      var direct_filters = [];
      angular.forEach(result.direct_filters, function(value, key) {
        direct_filters.push(key);
      });
      if (direct_filters.length > 0) {
        FilterService.setFilter('direct_filters', direct_filters.join(','), true);
      }
      if(report && report.shared && report.filters && !report.filters['account']){
          if (!hasHierarchyFilter()) {
            let accounts  = $scope.filterService.accounts.map(account => account.id);
            accounts = accounts.toString();
            FilterService.setFilter('account_reports', accounts);
            filters.push('account_reports')
          }
      }
      ReportService.setTitleQuick(result.name);
      ReportService.setQuickReport(result);
      ReportService.setDetailsView(result.filters.detailed);
      FilterService.setFilter('filters', filters);
      var type = result.report_type ? result.report_type.toString() : result.report_type;
      $scope.goToReport(type);
    });
  };

  $scope.showReportDeleteDialog = function(report) {
    ngDialog.open({
      template: 'views/templates/dialog/report/delete.html',
      controller: 'ReportDeleteDialog',
      data: { report: report }
    });
  };


  //TODO: we can remove this if not being used anymore
  $scope.reportOwner = function(report) {
    if (!report) {
      return false;
    }
    else if (!report.account) {
      return AuthDataService.isAdmin() || (report.white_label && AuthDataService.isWhiteLabelAdmin());
    }
    else if (report.account_user) {
      return report.account_user.id === AccountUserService.currentAccountUser.id;
    }
  };

  $scope.accountOwner = function(report) {
    if (!report) {
      return false;
    } else if (!report.account) {
      return AuthDataService.isAdmin() || (report.white_label && AuthDataService.isWhiteLabelAdmin());
    }
    else if(PermissionService.isAccountOwner()) {
      return true;
    }
    else if (report.account_user) {
      return report.account_user.id === AccountUserService.currentAccountUser.id;
    }
  };

  $scope.expandReport = function(report) {
    if ($scope.isReportExpanded(report)) {
      $scope.reportExpanded = null;
      return;
    }
    $scope.reportExpanded = report.id;
  };

  $scope.isReportExpanded = function(report) {
    return $scope.reportExpanded && ($scope.reportExpanded == report.id);
  };

  $scope.$on('filter-selection:updated', function() {
    $scope.refresh();
  });

  $scope.showExportDialog = function(report) {
    ReportFilterService.showExportDialog({report_type: report.report_type, filters: report.filters});
  };

  $scope.goToCustomReport = function(group) {
    ReportService.removeQuickReport();
    FilterService.clearFilters();
    $scope.goToReport(group.id);
  };

  $scope.cleanFilters = function(type) {
    var filters = [];
    if ((type !== null) && (type !== undefined) && (type !== '')) {
      switch (type.toString()) {
        case ReportService.TYPE_ACTION_ITEM:
          filters = ReportService.filtersActionItem;
          break;
        case ReportService.TYPE_DYNAMIC_FORM:
          filters = ReportService.filtersDynamic;
          break;
        case ReportService.TYPE_ACTIVITY:
          filters = ReportService.filtersActivity;
          break;
        case ReportService.TYPE_UNIT:
        case ReportService.TYPE_WORKFLOW:
          filters = ReportService.filtersWorkFlow;
          break;
        case ReportService.TYPE_TEMPLATE:
          filters = ReportService.filtersTemplate;
          break;
        case ReportService.TYPE_PROPERTY:
          filters = ReportService.filtersProperty;
          break;
        case ReportService.TYPE_USER:
          filters = ReportService.filtersUser;
          break;
        case ReportService.TYPE_ON_DEMAND_INSTRUCTION:
          filters = ReportService.filtersOnDemandInstruction;
          break;
        case ReportService.TYPE_WORK_ORDERS:
          filters = ReportService.filtersWorkOrders;
          break;

      }
    }
    angular.forEach(filters, function(value){
      if (!_.contains(['portfolio_reports', 'property_reports'], value)) {
        FilterService.removeFilter(value, true);
      }
    });
    ReportService.removeQuickReport();
  };

  $scope.showCloneReport = function($report) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/report/clone-report.html',
      controller: 'ReportDialog',
      data: {
        report_type: $report.report_type,
        filters: $report.filters,
        schedule: $report.schedule,
        report_info: $scope.report,
      }
    }).then(function () {
      $scope.refresh();
    });
  };

  $scope.$on('report:deleted', $scope.refresh);
  $scope.$on('report:updated', function() {
    $scope.reportExpanded = null;
    $scope.refresh();
  });

  $timeout(function () {
    $scope.refresh();
  }, 0);

};

app.controller('ReportsQuickList', ['$scope', '$state', '$filter', 'FilterService', 'ngDialog',
  'QuickReportsService', 'ReportService', 'AuthDataService',
  'ReportFilterService','AccountUserService', 'PermissionService', '$rootScope', '$timeout', 'AnalyticsService', ReportsQuickList]);
